import { SubmitButton } from './styles';

export default SubmitButton;
